<template>
    <footer class="footer">
        <contact-modal :navbarModalPhoneNumber="navbarModalPhoneNumber" />

        <div class="social">
            <a
                href="https://www.instagram.com/drivefaaren"
                target="_blank"
                class="social-item instagram"
            >
                <i class="fab fa-instagram"></i>
                <span>Instagram</span>
            </a>
            <a
                href="https://www.facebook.com/drivefaaren"
                target="_blank"
                class="social-item facebook"
            >
                <i class="fab fa-facebook-f"></i>
                <span>Facebook</span>
            </a>
            <a
                href="https://www.linkedin.com/company/faaren/"
                target="_blank"
                class="social-item instagram"
            >
                <i class="fab fa-linkedin-in"></i>
                <span>LinkedIn</span>
            </a>
        </div>

        <div class="info row text-center">
            <div class="payment col-sm-12 col-md-12 col-lg-6 col-xl-4 col-12">
                <strong>Bequeme Onlinezahlung</strong>
                <div
                    class="payment-logos d-flex justify-content-center flex-wrap gap-2 mt-2"
                >
                    <div class="paymentIcons">
                        <img
                            src="https://storage.googleapis.com/faa-files/payment-options/mastercard.svg"
                            alt="Mastercard Logo"
                        />
                    </div>
                    <div class="paymentIcons">
                        <img
                            src="https://storage.googleapis.com/faa-files/payment-options/visa.svg"
                            alt="Visa Logo"
                        />
                    </div>
                    <div class="paymentIcons">
                        <img
                            src="https://storage.googleapis.com/faa-files/payment-options/americanexpress.svg"
                            alt="American Express Logo"
                        />
                    </div>
                </div>
            </div>

            <div class="rating col-sm-12 col-md-12 col-lg-6 col-xl-4 col-12">
                <strong>FAAREN Marktplatz Bewertungen</strong>
                <google-rating></google-rating>
            </div>

            <div class="newsletter col-sm-12 col-md-12 col-lg-6 col-xl-4 col-12">
                <strong>Auf dem Laufenden bleiben</strong>
                <div class="mt-2">
                    <f-button
                        variant="outline-secondary"
                        modalId="newsletter-modal"
                        class="hvr-icon-forward footer-link"
                    >
                        Newsletter abonnieren
                    </f-button>
                </div>
                <f-modal id="newsletter-modal" hide-footer>
                    <footer-newsletter-modal></footer-newsletter-modal>
                </f-modal>
            </div>
        </div>

        <div class="menu row">
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 col-12">
                <strong>Service</strong>
                <ul>
                    <li><a href="https://help.faaren.com/">FAQs & Hilfe</a></li>
                    <li><a href="/agbs">AGB</a></li>
                    <li><a href="/kontakt">Kontakt</a></li>
                    <li><a href="/cancel-subscription">Abo kündigen</a></li>
                </ul>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 col-12">
                <strong>Rechtliches</strong>
                <ul>
                    <li><a href="/impressum">Impressum</a></li>
                    <li><a href="/datenschutz">Datenschutzerklärung</a></li>
                    <li><a href="/haftungsausschluss">Haftungsausschluss</a></li>
                    <li class="cookie--banner-hint">
                        <a href="javascript:void(0);" onclick="cookiefirst_show_settings();">
                            Cookie-Einstellungen
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 col-12">
                <strong>Unternehmen</strong>
                <ul>
                    <li><a href="/ueber-uns">Über FAAREN</a></li>
                    <li><a href="/karriere">Karriere</a></li>
                    <li><a href="/presse">Presse</a></li>
                </ul>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3 col-12">
                <strong>Für Anbieter</strong>
                <ul>
                    <li><a href="https://faaren-group.com">Abo Anbieter werden</a></li>
                    <li v-if="!isProducer">
                        <a href="https://partner.faaren.com/login">Partner-Login</a>
                    </li>
                    <li v-else>
                        <a href="https://partner.faaren.com">Partner-Dashboard</a>
                    </li>
                </ul>
            </div>
        </div>
    </footer>
</template>
<script>
import { FContainer, FRow, FCol, FImage } from "faaren-ui";

export default {
    name: "FaarenFooter",
    components: {
        FContainer,
        FRow,
        FCol,
        FImage,
    },
    props: {
        isProducer: {
            type: Boolean,
            default: false,
        },
        loggedIn: {
            required: false,
            default: null,
            type: null | Object,
        },
        navbarModalPhoneNumber: {
            default: false,
        },
    },
};
</script>

<style lang="scss">
.star-color {
    color: #ffbf00;
}
.link-list {
    background: black;
    color: #fff;
    a {
        color: #fff;
        &:hover {
            text-decoration: none;
            color: #fff;
        }
    }
}
.legal {
    color: #1e1e2d;
    background: #eceaea;
    a {
        color: #1e1e2d;
        &:hover {
            text-decoration: none;
            color: #1e1e2d;
        }
    }
}
.sticky-contact-button {
    position: fixed;
    bottom: 20px;
    left: 20px;
    z-index: 1040;
}
.paymentIcons {
    padding-right: 1.5rem;
    margin-bottom: 1rem;
    width: 80px;
}
</style>
